import { useEffect, useState } from 'react';
import AUX from '../../../../hoc/Aux_';
import { Button } from 'reactstrap';
import moment from 'moment';
import ActivityAddModel from '../Activity/ActivityAddModel';
import { useDispatch, useSelector } from 'react-redux';
import {
  getMonitoringMember,
  getProjects,
  getMonitoringScreenshot,
} from '../../../../redux/MainAction';
import ImagesModal from './ImagesModal';
import TimeTrackingCard from './TimeTrackingCard';
import Axios from 'axios';
import Constant, { getExeVersions } from '../../../../Constant';
import ScreenshotViewer from './ScreenshotViewer';
import PageLoader from '../../../../components/HOC/PageLoader';
import { toast } from 'react-toastify';
import VersionSelector from '../../../VersionManagement/version-selector';

const ScreenShots = () => {
  const dispatch = useDispatch();

  const member = useSelector((state) => state.Webtracker.monitoringMember);
  const project = useSelector((state) => state.Webtracker.projects);

  const [version, setVersion] = useState(getExeVersions()[0]?.value);

  useEffect(() => {
    dispatch(
      getMonitoringMember({
        offset: 0,
        limit: 100,
      })
    );

    dispatch(getProjects());
  }, []);

  return (
    <ScreenShotsVersion
      key={version}
      version={version}
      member={member}
      project={project}
    >
      <VersionSelector version={version} setVersion={setVersion} />
    </ScreenShotsVersion>
  );
};

const ScreenShotsVersion = ({ version, children, member, project }) => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [apiCalls, setApiCalls] = useState(false);
  const [showReset, setShowReset] = useState(false);

  const shots = useSelector((state) => state.Webtracker.monitoringScreenshot);
  const summary = shots && shots?.summary;
  const date = new Date();

  const [filts, setFilts] = useState({
    employeeId: '',
    projectId: '',
    date: moment(date).format('YYYY-MM-DD'),
  });

  const [emp, setEmp] = useState([]);
  const [proj, setProj] = useState([]);

  useEffect(() => {
    if (member && member?.rows) {
      setEmp(member?.rows);
    }
    if (project && project?.rows) {
      setProj(project?.rows);
    }
  }, [member, project]);

  const onChangeFilters = (e) => {
    const { name, value } = e.target;
    setFilts({ ...filts, [name]: value });
  };

  const handleApply = async (e) => {
    e.preventDefault();

    if (!filts?.employeeId) {
      toast.error('Please select a member to see the screenshots');
      return;
    }

    setIsLoading(true);
    setApiCalls(true);

    const data = {
      employeeId: filts?.employeeId,
      date: moment(filts?.date).format('YYYY-MM-DD'),
    };

    if (filts?.projectId) {
      data.projectId = filts?.projectId;
    }

    await dispatch(getMonitoringScreenshot(data, version === '1.1.8'));
    setShowReset(true);
    setIsLoading(false);
  };

  const handleReset = async (e) => {
    e.preventDefault();

    const resetFilters = {
      employeeId: '',
      projectId: '',
      date: moment(date).format('YYYY-MM-DD'),
    };

    setFilts(resetFilters);
    setShowReset(false);
    setApiCalls(false);
  };

  // Modal
  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const [isEditOpen, setIsEditOpen] = useState(false);
  const [editID, setEditID] = useState({});
  // Function to toggle the modal visibility

  const toggleEdit = (id) => {
    setIsEditOpen(!isEditOpen);
    setEditID(id);
  };

  const groupScreenshotsByHour = (screenshots) => {
    const groupedData = {};

    // Sort screenshots by `createdAt`
    const sortedScreenshots = [...screenshots].sort(
      (a, b) => new Date(a.createdAt) - new Date(b.createdAt)
    );

    sortedScreenshots.forEach((screenshot) => {
      const hour = moment(screenshot.createdAt).format('HH:00');
      if (!groupedData[hour]) {
        groupedData[hour] = [];
      }
      groupedData[hour].push(screenshot);
    });

    return groupedData;
  };

  const [groupedScreenshots, setGroupedScreenshots] = useState({});

  const filterWorkingHours = (groupedData) => {
    const workingHours = {};
    const startHour = 0; // 12:00 AM
    const endHour = 23; // 11:59 PM

    Object.keys(groupedData).forEach((hour) => {
      const hourInt = parseInt(hour.split(':')[0], 10);
      if (hourInt >= startHour && hourInt <= endHour) {
        workingHours[hour] = groupedData[hour];
      }
    });

    return workingHours;
  };

  useEffect(() => {
    if (shots?.screenshots) {
      const grouped = groupScreenshotsByHour(shots.screenshots);
      const filteredGrouped = filterWorkingHours(grouped);
      setGroupedScreenshots(filteredGrouped);
    }
  }, [shots]);

  const onDownload = async () => {
    try {
      // Ensure `filts` and `date` are defined before accessing
      if (!filts || !filts.employeeId || !date) {
        console.error('Missing required filters or date');
        return;
      }

      const payload = {
        employeeId: filts.employeeId, // Directly accessing employeeId since filts is checked
        date: filts.date, // Make sure date is in the correct format
      };

      // Get the token from localStorage
      const token = localStorage.getItem('loged_In_auth');

      // Make an API request to fetch the zip file
      const response = await Axios.post(
        Constant.getAPI() + `user/monitoring/screenshots/download`,
        payload,
        {
          responseType: 'arraybuffer', // Important to handle binary data (zip file)
          headers: {
            Authorization: `Bearer ${token}`, // Add the token in the headers object
          },
        }
      );

      // Check if the response is valid
      if (response.status === 200 && response.data) {
        // Create a Blob from the binary response
        const blob = new Blob([response.data], { type: 'application/zip' });

        console.log('blob', blob); // Log the Blob object

        // Create a link to trigger the download
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob); // Create an object URL for the Blob
        link.download = 'download.zip'; // Specify the file name
        link.click(); // Programmatically trigger the download
      } else {
        console.error('Failed to fetch the file');
      }
    } catch (error) {
      console.error('Error downloading file', error);
    }
  };

  return (
    <PageLoader isLoading={isLoading}>
      <AUX>
        <div className="page-content-wrapper">
          <ActivityAddModel open={isModalOpen} onClose={toggleModal} />
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="row">
                  <div className="col-12">
                    <div className="card m-b-20">
                      <div className="card-body">
                        <div
                          className="d-flex justify-content-between align-items-center mb-4"
                          style={{ gap: '15px' }}
                        >
                          <div
                            className="d-flex justify-content-start align-items-center"
                            style={{ gap: '10px' }}
                          >
                            {children}

                            <select
                              className="form-control"
                              style={{ width: '215px', cursor: 'pointer' }}
                              name="employeeId"
                              value={filts?.employeeId}
                              onChange={onChangeFilters}
                            >
                              <option value="">--Select Member--</option>
                              {emp?.map((employee, idx) => (
                                <option key={idx} value={employee?.user?.id}>
                                  {employee?.user?.firstName}{' '}
                                  {employee?.user?.lastName}
                                </option>
                              ))}
                            </select>

                            <select
                              className="form-control"
                              style={{ width: '215px', cursor: 'pointer' }}
                              name="projectId"
                              value={filts?.projectId || ''}
                              onChange={onChangeFilters}
                            >
                              <option value="">--Select Project--</option>
                              {proj?.map((prj, idx) => (
                                <option key={idx} value={prj?.id}>
                                  {prj?.name}
                                </option>
                              ))}
                            </select>

                            <input
                              type="date"
                              className="form-control"
                              id="username2"
                              name="date"
                              value={filts?.date}
                              onChange={onChangeFilters}
                              style={{ width: '200px' }}
                            />

                            <Button
                              className="d-flex align-items-center justify-content-center"
                              style={{ padding: '6px 14px' }}
                              size="sm"
                              color="primary"
                              onClick={handleApply}
                            >
                              <i className="ion-ios7-search font-20"></i>
                            </Button>

                            {showReset && (
                              <Button
                                className="d-flex align-items-center justify-content-center"
                                style={{ padding: '6px 13px' }}
                                size="sm"
                                color="danger"
                                onClick={handleReset}
                              >
                                <i className="mdi mdi-close font-20"></i>
                              </Button>
                            )}
                          </div>

                          <div
                            className="d-flex justify-content-start align-items-center"
                            style={{ gap: '10px' }}
                          >
                            <Button
                              onClick={onDownload}
                              outline
                              color="dark"
                              size="sm"
                              className="d-flex justify-content-center align-items-center"
                              disabled={
                                !apiCalls || !shots?.screenshots?.length
                              }
                            >
                              <i className="mbri-save mr-2"></i> Download
                            </Button>
                          </div>
                        </div>

                        {version !== '1.1.8' && apiCalls && summary && (
                          <TimeTrackingCard
                            summary={{
                              total: summary?.total,
                              tracked: summary?.tracked,
                              manuallyAdded: summary?.manuallyAdded,
                              idle: summary?.idle,
                              paidLeave: summary?.paidLeave,
                              break: summary?.break,
                            }}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card m-b-20">
                  {apiCalls ? (
                    shots?.screenshots?.length > 0 ? (
                      <ScreenshotViewer
                        groupedScreenshots={groupedScreenshots}
                        shots={shots}
                        toggleEdit={toggleEdit}
                      />
                    ) : (
                      <div className="card-body text-center">
                        <p>No screenshots found</p>
                      </div>
                    )
                  ) : (
                    <div className="card-body text-center">
                      <p>
                        Please click on the search button to view screenshots
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <ImagesModal open={isEditOpen} onClose={toggleEdit} ID={editID} />
      </AUX>
    </PageLoader>
  );
};

export default ScreenShots;
